module.exports = __webpack_public_path__ + "static/media/close.003f24a8.svg";